import React from "react";
import { useNavigate } from "react-router-dom";

export default function ShopWhy() {
  const nav = useNavigate();

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <button
          onClick={() => nav("/shop/auth")}
          style={styles.backBtn}
        >
          ← Back to Shop Login
        </button>
      </div>

      {/* Hero Section */}
      <div style={styles.hero}>
        <div style={{ fontSize: "clamp(32px, 8vw, 56px)", fontWeight: 900, marginBottom: 20, color: "#fff" }}>
          🚀 Why Moondala?
        </div>
        <div style={{ fontSize: "clamp(16px, 3vw, 22px)", color: "rgba(255, 255, 255, 0.9)", lineHeight: "1.6", maxWidth: 600 }}>
          The best platform for sellers who want to grow globally, earn more, and build their brand.
        </div>
      </div>

      {/* Content Sections - Ready for Photos & Text */}
      <div style={styles.content}>
        {/* Section 1: Global Reach */}
        <div style={styles.section}>
          <div style={styles.sectionNumber}>1</div>
          <div style={{ flex: 1 }}>
            <h2 style={styles.sectionTitle}>🌍 Global Reach</h2>
            <p style={styles.sectionText}>
              Sell to customers in 50+ countries. Moondala connects you with millions of buyers worldwide.
            </p>
            {/* Photo placeholder */}
            <div style={styles.photoPlaceholder}>
              [Add Global Map / World Photo Here]
            </div>
          </div>
        </div>

        {/* Section 2: Better Payouts */}
        <div style={styles.section}>
          <div style={styles.sectionNumber}>2</div>
          <div style={{ flex: 1 }}>
            <h2 style={styles.sectionTitle}>💰 Better Commission Rates</h2>
            <p style={styles.sectionText}>
              Earn 90-94% from your sales. Our commission rates are the best in the industry (vs 75-85% elsewhere).
            </p>
            {/* Photo placeholder */}
            <div style={styles.photoPlaceholder}>
              [Add Revenue Chart / Growth Photo Here]
            </div>
          </div>
        </div>

        {/* Section 3: Analytics */}
        <div style={styles.section}>
          <div style={styles.sectionNumber}>3</div>
          <div style={{ flex: 1 }}>
            <h2 style={styles.sectionTitle}>📊 Advanced Analytics</h2>
            <p style={styles.sectionText}>
              Real-time sales data, customer insights, and AI-powered recommendations to grow your business.
            </p>
            {/* Photo placeholder */}
            <div style={styles.photoPlaceholder}>
              [Add Dashboard / Analytics Screenshot Here]
            </div>
          </div>
        </div>

        {/* Section 4: Custom Mall */}
        <div style={styles.section}>
          <div style={styles.sectionNumber}>4</div>
          <div style={{ flex: 1 }}>
            <h2 style={styles.sectionTitle}>🎨 Beautiful Store Builder</h2>
            <p style={styles.sectionText}>
              Create a stunning custom store in minutes without coding. Drag, drop, and launch.
            </p>
            {/* Photo placeholder */}
            <div style={styles.photoPlaceholder}>
              [Add Store Builder Screenshot Here]
            </div>
          </div>
        </div>

        {/* Section 5: Community */}
        <div style={styles.section}>
          <div style={styles.sectionNumber}>5</div>
          <div style={{ flex: 1 }}>
            <h2 style={styles.sectionTitle}>🤝 Seller Community</h2>
            <p style={styles.sectionText}>
              Connect with other sellers, share tips, and grow together. We're building a marketplace, not just a platform.
            </p>
            {/* Photo placeholder */}
            <div style={styles.photoPlaceholder}>
              [Add Community / Network Photo Here]
            </div>
          </div>
        </div>

        {/* Section 6: No Hidden Fees */}
        <div style={styles.section}>
          <div style={styles.sectionNumber}>6</div>
          <div style={{ flex: 1 }}>
            <h2 style={styles.sectionTitle}>✅ Transparent Pricing</h2>
            <p style={styles.sectionText}>
              No hidden fees. No surprise charges. Just honest, upfront pricing that lets you keep more of what you earn.
            </p>
            {/* Photo placeholder */}
            <div style={styles.photoPlaceholder}>
              [Add Pricing Table / Trust Illustration Here]
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div style={styles.cta}>
        <h2 style={{ fontSize: "clamp(24px, 5vw, 32px)", fontWeight: 900, marginBottom: 20 }}>
          Ready to Grow Your Business?
        </h2>
        <p style={{ fontSize: "clamp(14px, 2vw, 16px)", color: "rgba(255, 255, 255, 0.8)", marginBottom: 30 }}>
          Join thousands of sellers already earning more on Moondala.
        </p>
        <button
          onClick={() => nav("/shop/auth")}
          style={styles.ctaBtn}
        >
          Register Your Shop Now
        </button>
      </div>

      {/* Footer */}
      <div style={styles.footer}>
        <p>© 2026 Moondala Inc. All rights reserved.</p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #0f0f1e 0%, #1a0033 50%, #0f0f1e 100%)",
    color: "#fff",
    fontFamily: "system-ui, -apple-system, sans-serif",
    paddingBottom: 60,
  },
  header: {
    padding: "clamp(16px, 3vw, 24px) clamp(20px, 5vw, 40px)",
    borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
  },
  backBtn: {
    background: "none",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    color: "rgba(255, 255, 255, 0.7)",
    padding: "8px 16px",
    borderRadius: 8,
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: 600,
    transition: "all 0.2s ease",
  },
  hero: {
    textAlign: "center",
    padding: "clamp(40px, 8vw, 80px) clamp(20px, 5vw, 40px)",
    background: "linear-gradient(135deg, rgba(147, 51, 234, 0.15) 0%, rgba(59, 130, 246, 0.1) 100%)",
    borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
  },
  content: {
    maxWidth: 1000,
    margin: "0 auto",
    padding: "clamp(40px, 8vw, 60px) clamp(20px, 5vw, 40px)",
  },
  section: {
    display: "grid",
    gridTemplateColumns: "60px 1fr",
    gap: "clamp(20px, 4vw, 40px)",
    marginBottom: "clamp(40px, 8vw, 60px)",
    paddingBottom: "clamp(40px, 8vw, 60px)",
    borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
  },
  sectionNumber: {
    fontSize: "clamp(32px, 6vw, 48px)",
    fontWeight: 900,
    color: "rgba(147, 51, 234, 0.9)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  sectionTitle: {
    fontSize: "clamp(18px, 4vw, 24px)",
    fontWeight: 900,
    marginBottom: 12,
    color: "#fff",
  },
  sectionText: {
    fontSize: "clamp(14px, 2.5vw, 16px)",
    color: "rgba(255, 255, 255, 0.8)",
    lineHeight: "1.8",
    marginBottom: 20,
  },
  photoPlaceholder: {
    width: "100%",
    height: "300px",
    background: "rgba(147, 51, 234, 0.1)",
    border: "2px dashed rgba(147, 51, 234, 0.3)",
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "rgba(147, 51, 234, 0.6)",
    fontSize: "14px",
    fontWeight: 600,
  },
  cta: {
    textAlign: "center",
    padding: "clamp(40px, 8vw, 60px) clamp(20px, 5vw, 40px)",
    background: "linear-gradient(135deg, rgba(147, 51, 234, 0.15) 0%, rgba(59, 130, 246, 0.1) 100%)",
    borderTop: "1px solid rgba(255, 255, 255, 0.1)",
  },
  ctaBtn: {
    padding: "clamp(12px, 2.5vw, 16px) clamp(28px, 6vw, 40px)",
    borderRadius: 12,
    border: "none",
    background: "linear-gradient(135deg, #9333ea 0%, #7c3aed 100%)",
    color: "#fff",
    fontWeight: 900,
    fontSize: "clamp(14px, 2.5vw, 16px)",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  footer: {
    textAlign: "center",
    padding: "20px",
    fontSize: "12px",
    color: "rgba(255, 255, 255, 0.5)",
    borderTop: "1px solid rgba(255, 255, 255, 0.1)",
  },
};
